import React, {PureComponent} from 'react';

import {getCurrentUserId, getJwt, getCurrentUserName} from '../../../services/authService';
import http from '../../../services/httpService';
import countries from '../../common/countries';
import usStates from '../../common/usStates';
import {Button, MenuItem} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import InputRegular from '../../common/InputRegular';
import Header from '../Header'
import {Link} from 'react-router-dom'

import authService from "../../../services/authService";
// import ReactGA from "react-ga";
import axios from "axios";

class InsertName extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            user: '',
            firstName: '',
            lastName: '',
            country: '',
            countryName: 'Select Country',
            filteredCountries: [],
            filteredStates: [],
            selectedUsState: {
                name: 'Select State',
                abbreviation: ''
            },
            fieldsCheckActive: false,
            spinnerActive: false,
            errors: {},
            errorsList: []
        };
    }

    doSubmit = async (type = null) => {
        this.setState({fieldsCheckActive: true})
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Insert user name - Next',
        //     userId: getCurrentUserId() //+' - '+getCurrentUserName()
        //     ,
        //     label: '',
        //     nonInteraction: true
        // });

        let anyErrorActive = await false;
        await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
        // console.log('Iz do submit: ', anyErrorActive, this.state.errorsList, this.state.firstName, this.state.lastName, this.state.country, this.state.formatedPhone, this.state.selectedUsState.abbreviation, this.isPhoneNumber())
        if (!anyErrorActive && this.state.firstName && this.state.lastName && this.state.country && (this.state.selectedUsState.abbreviation || this.state.country !== 'US')) {
            try {
                const userId = await getCurrentUserId();
                // let index = this.state.data.name.indexOf(" ");  // Gets the first index where a space occurs
                authService.setCurrentUserName(this.state.firstName);
                // let first_name = this.state.data.name.substr(0, index); // Gets the first part
                // let last_name = this.state.data.name.substr(index + 1);  // Gets the text part
                let first_name = this.state.firstName;
                let last_name = this.state.lastName;
                let countryCode = this.state.country;
                let countryName = this.state.countryName
                if (userId) {
                    await this.setState({spinnerActive: true});
                    const resp = await http.patch('api/user/' + userId, {
                        first_name: first_name,
                        last_name: last_name,
                        country: countryCode,
                        country_name: countryName,
                        state: this.state.selectedUsState.abbreviation || ''
                    }, {headers: {authorization: getJwt()}});
                    if (resp.data.data.name) {
                        const result = await http.get('api/user/' + getCurrentUserId() + '/teams', {headers: {authorization: getJwt()}});
                        let userTeamsIn = await result.data.teams_in.data;
                        let projectsShared = await result.data.feeds_shared;
                        if (userTeamsIn && userTeamsIn.length) {
                            let projectInTeam = false;
                            await userTeamsIn.map(team => team.feeds && team.feeds.length ? projectInTeam = true : '');
                            await this.props.updateUserFromServer();
                            projectInTeam ? this.props.history.push('/channels') : this.props.history.push('feed-name');
                            // } else if (projectsShared && projectsShared.length){
                            //     this.props.history.push('/channels')
                        } else {
                            await this.props.updateUserFromServer();
                            this.props.history.push('/insert-phone')
                        }
                    }

                    if (process.env.REACT_APP_ENVIRONMENT === 'PROD') {

                        const iubendaPatchData = {
                            "first_name": first_name,
                            "last_name": last_name,
                            "full_name": first_name + ' ' + last_name
                        }

                        // console.log('iubendaPatchData: ', iubendaPatchData)

                        const iubendaUserId = await localStorage.getItem('iubendaUserId')
                        // console.log('insert - iubendaUserId: ', iubendaUserId)
                        const iubendaPatchResponse = await axios.patch('https://consent.iubenda.com/subjects/' + iubendaUserId, iubendaPatchData,
                            {
                                headers: {
                                    'ApiKey': process.env.REACT_APP_IUBENDA_API_KEY,
                                    'Content-Type': 'application/json'
                                }
                            }
                        )
                        //console.log('iubendaResponse: ', iubendaPatchResponse)
                    }
                    this.setState({spinnerActive: false});
                }
            } catch (ex) {
                this.setState({spinnerActive: false});
                if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                    const errors_obj = this.state.errors;
                    let errors = {...errors_obj};
                    //console.log(ex.response.data);
                    errors = ex.response.data.errors;
                    this.setState({errors});
                }
            }
        }
    };

    getUserData = async () => {
        const userId = await getCurrentUserId();
        if (userId) {
            try {
                const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
                const data = await result.data.data;
                if (data !== this.state.user) {
                    await this.setState({user: data})
                }
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.props.history.push('/logout');
                if (ex.response && ex.response.status === 401) {
                    this.props.history.push('/logout');
                }
            }
        }
    }

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
        // console.log('Errors list data: ', error, id, errorsList);
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
            .split(/\s+/g)
            .map(s => s.trim())
            .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
                .map((word, i) => {
                    if (i + 1 === words.length && !hasTrailingSpace) {
                        // The last word - ok with the word being "startswith"-like
                        return `(?=.*\\b${escapeRegExp(word)})`;
                    } else {
                        // Not the last word - expect the whole word exactly
                        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                    }
                })
                .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    filterStates = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
            .split(/\s+/g)
            .map(s => s.trim())
            .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
                .map((word, i) => {
                    if (i + 1 === words.length && !hasTrailingSpace) {
                        // The last word - ok with the word being "startswith"-like
                        return `(?=.*\\b${escapeRegExp(word)})`;
                    } else {
                        // Not the last word - expect the whole word exactly
                        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                    }
                })
                .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        usStates.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredStates: filteredArray
        })
    };

    componentDidMount() {
       // ReactGA.pageview(window.location.pathname + window.location.search);
        this.getUserData();
        this.setState({
            filteredCountries: countries,
            filteredStates: usStates
        })

        if (this.state.user && this.state.user.active === 0) {
            this.props.history.push('email-verification')
        }
    }

    render() {
        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title m-xxl-b'>Tell us a bit about yourself</h1>

                        <InputRegular
                            id="1"
                            label1="First Name"
                            placeholder="First Name"
                            type='text'
                            required={true}
                            onChange={value => this.setState({firstName: value})}
                            value={this.state.firstName}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="This field is required"
                        />

                        <InputRegular
                            id="2"
                            label1="Last Name"
                            placeholder="Last Name"
                            type='text'
                            required={true}
                            onChange={value => this.setState({lastName: value})}
                            value={this.state.lastName}
                            fieldsCheckActive={this.state.fieldsCheckActive}
                            updateErrorsList={this.updateErrorsList}
                            errorMessage="This field is required"
                            spaceBellowInput={1}
                        />

                        <div style={{margin: '0 0 20px 0'}}>
                            <Select
                                items={this.state.filteredCountries}
                                itemRenderer={(item, index) => <MenuItem
                                    key={index}
                                    onClick={() => {
                                        this.setState({
                                            country: item.code,
                                            countryName: item.name
                                        })
                                    }}
                                    text={item.name + ' ' + item.flag}
                                />}
                                filterable={true}
                                onQueryChange={this.filterItems}
                                resetOnClose={true}
                            >
                                <p style={{fontSize: 12, marginBottom: 0}}>Country</p>
                                <Button
                                    className={(this.state.countryName === 'Select Country') && this.state.fieldsCheckActive ? 'country-selector-error' : this.state.countryName === 'Select Country' ? 'country-selector-empty' : 'country-selector'}
                                    text={this.state.countryName}
                                    rightIcon="caret-down">
                                </Button>

                            </Select>
                            {
                                (this.state.countryName === 'Select Country') && this.state.fieldsCheckActive ?
                                    <div className="selector-error-label" style={{marginTop: 5}}>This field is
                                        required</div>
                                    :
                                    <div className='selector-error-label' style={{marginTop: 5}}></div>
                            }
                        </div>
                        {this.state.country === 'US' ?
                            <div style={{margin: '-20px 0 20px 0'}}>
                                <Select
                                    items={this.state.filteredStates}
                                    itemRenderer={(item, index) => <MenuItem
                                        key={index}
                                        onClick={() => {
                                            this.setState({
                                                selectedUsState: item
                                            })
                                        }}
                                        text={item.name}
                                    />}
                                    filterable={true}
                                    onQueryChange={this.filterStates}
                                    resetOnClose={true}
                                >
                                    <p style={{fontSize: 12, marginBottom: 0}}>State</p>
                                    <Button
                                        className={(this.state.selectedUsState.name === 'Select State') && this.state.fieldsCheckActive ? 'country-selector-error' : this.state.selectedUsState.name === 'Select State' ? 'country-selector-empty' : 'country-selector'}
                                        text={this.state.selectedUsState.name}
                                        rightIcon="caret-down">
                                    </Button>

                                </Select>
                                {
                                    (this.state.selectedUsState.name === 'Select State') && this.state.fieldsCheckActive ?
                                        <div className="selector-error-label" style={{marginTop: 5}}>This field is
                                            required</div>
                                        :
                                        <div className='selector-error-label' style={{marginTop: 5}}></div>
                                }
                            </div>
                            :
                            ''
                        }
                        {this.state.spinnerActive ?
                            <button className='btn-action btn-spinner'>Next <i className='fa fa-spin fa-spinner'></i>
                            </button>
                            :
                            <button className='btn-action' onClick={this.doSubmit}>Next</button>
                        }

                        <div className='panel-message'>
                            <p>By registering on our website you are agreeing to our <a target='_blank'
                                                                                        href="https://emitto.io/terms-of-service">Customer
                                Terms of Service,
                                Privacy Policy, Cookie Policy.
                            </a></p>
                        </div>
                    </div>
                    {/*{console.log('formatedPhone: ', this.state.formatedPhone)}*/}
                </div>

            </div>
        )
    }
}

export default InsertName;